import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useState,
} from "react"

import { OrganizationsResponses } from "@tfg/types/endpoints/organizations"
import { SubscriptionPlan } from "@tfg/types/endpoints/subscriptionPlan"

import { useGetOrganizationSubscriptionPlanPermissions } from "~/pages/Brand/CommunicationStudio/OrganizationGeneralSettings/hooks/useGetOrganizationSubscriptionPlanPermissions"

interface OrganizationSubscriptionPlanPermissionsProviderProps {
  children: ReactNode
  initialSubscriptionPlan: OrganizationsResponses.OrganizationSettings["subscriptionPlan"]
}

export type OrganizationSubscriptionPlanPermissionsContextType = {
  permissions:
    | OrganizationsResponses.OrganizationSubscriptionPlanPermissions["permissions"]
    | undefined
  isPermissionsError: boolean
  setSubscriptionPlan: Dispatch<SetStateAction<SubscriptionPlan>>
}

export const OrganizationSubscriptionPlanPermissionsContext = createContext<
  OrganizationSubscriptionPlanPermissionsContextType | undefined
>(undefined)

export const OrganizationSubscriptionPlanPermissionsProvider = ({
  children,
  initialSubscriptionPlan,
}: OrganizationSubscriptionPlanPermissionsProviderProps) => {
  const [subscriptionPlan, setSubscriptionPlan] = useState<SubscriptionPlan>(
    initialSubscriptionPlan
  )
  const { permissions, isPermissionsError } =
    useGetOrganizationSubscriptionPlanPermissions(subscriptionPlan)
  return (
    <OrganizationSubscriptionPlanPermissionsContext.Provider
      value={{ permissions, isPermissionsError, setSubscriptionPlan }}
    >
      {children}
    </OrganizationSubscriptionPlanPermissionsContext.Provider>
  )
}
